import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 },
  }),
};

const ServiceCard = ({ s, i }) => (
  <motion.div
    variants={reveal}
    custom={i}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    data-testid={`service-card-${s.id}`}
    className={`group relative flex flex-col justify-between overflow-hidden border border-white/10 bg-[#0c0c0c] p-7 min-h-[220px] transition-colors duration-300 hover:border-cyanbrand/60 ${s.span}`}
  >
    {s.image && (
      <div className="absolute inset-0 z-0">
        <img
          src={s.image}
          alt={s.title}
          className="h-full w-full object-cover grayscale opacity-20 transition-all duration-500 group-hover:opacity-35 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c0c] via-[#0c0c0c]/70 to-transparent" />
      </div>
    )}

    <div className="relative z-10 flex items-start justify-between">
      <span className="font-mono text-xs text-cyanbrand">{s.index}</span>
      <ArrowUpRight className="h-5 w-5 text-white/30 transition-all duration-300 group-hover:text-cyanbrand group-hover:rotate-45" />
    </div>

    <div className="relative z-10 mt-auto">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
        {s.tag}
      </span>
      <h3 className="mt-2 font-display text-2xl md:text-3xl font-medium tracking-tight">
        {s.title}
      </h3>
      <p className="mt-3 max-w-md font-body text-sm text-white/55 leading-relaxed">
        {s.desc}
      </p>
    </div>
  </motion.div>
);

export const Services = () => {
  return (
    <section id="services" data-testid="services" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-cyanbrand">
              / What we install
            </span>
            <h2 className="mt-4 max-w-2xl font-display text-4xl md:text-6xl font-medium tracking-tight">
              End-to-end security, built to last.
            </h2>
          </div>
          <p className="max-w-sm font-body text-sm text-white/50 leading-relaxed">
            One team for the survey, the wiring, the commissioning and the
            after-care — for homes and businesses alike.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:auto-rows-[220px]">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
